
<template>
  <div>
    <SelectDriver :model="model"></SelectDriver>
    <SelectTruck :model="model"></SelectTruck>
  </div>
</template>

<script>
export default {
  name: 'SelectDriverAndTruck',
  props: {
    model:{
      type: Object,
      require: true,
    }
  },
  components: {
    SelectDriver: () => import('./SelectDriver.vue'),
    SelectTruck: () => import("./SelectTruck.vue"),
  },
}
</script>
